import { render, staticRenderFns } from "./PageButton.vue?vue&type=template&id=477869cf&"
import script from "./PageButton.vue?vue&type=script&lang=js&"
export * from "./PageButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports